import PageTable from "components/PageTable";
import React from "react";
import '../Common.scss';
import styles from './InstructionPage.module.scss';
const headerList=["No","Category/SubCategory","Link To Instructions PDF"]//"Module Description"
const valuesKey=[ "no","category/subcategory","link"] //"moduleDescription"
export default class InstructionPage extends React.Component<any, any>{
    render() {
        const { pageDetails } = this.props;
        const { links } = pageDetails || {};
        const links_arr=[]
        links && links.map((link, index)=>{
            if(link){
            let no =index+1;
            let cat_subcat = decodeURIComponent(link.split('/').pop() || 'Link');
            let cat_subcat_trimmed = cat_subcat.split('.pdf');
            links_arr.push(Object.create({'no':no,'category/subcategory':cat_subcat_trimmed[0],'link':link}));
            }
            return link;
        });
        return (
            <React.Fragment>
            <div className={styles['instructionPage']}>
                <div className={styles['page-name']}>
                   {pageDetails?.name}
               </div>
               <div className="pageLinks" style={{position:"relative","zIndex": 11}}>
                    {
                            <PageTable tableName={''} headerList={headerList} valuesKey={valuesKey} valuesList={links_arr}></PageTable>
                    }
               </div>
            </div>
        </React.Fragment>
        )
    }

}